module.exports = __webpack_public_path__ + "static/media/7 Same Side Grip.bbf0a5c4.jpg";